import { handleAction } from 'redux-actions';
import { setInitialLoad, setSearchTerm } from '../actions/global';

export const initialLoadReducer = handleAction(
  setInitialLoad,
  (_, { payload }) => payload,
  true,
);

export const searchTermReducer = handleAction(
  setSearchTerm,
  (_, { payload }) => payload,
  '',
);



// WEBPACK FOOTER //
// ./src/redux/reducers/global.js